import React, { Fragment } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Signin from "../Auth/Signin";
import { useSelector } from "react-redux";
import { routes } from "./PrivateRoutes";
import ForgotPassword from "../Auth/ForgotPassword";
import VerifyCode from "../Auth/VerifyCode";
import ResetPassword from "../Auth/ResetPassword";
import Signup from "../Auth/Signup";
import UserVerified from "../Auth/UserVerified";

const Routers = () => {
  const authState = useSelector((state) => state.authReducer);
  const isAuthenticated = Boolean(authState?.accessToken);

  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        {isAuthenticated ? (
          <>
            {routes.map(({ path, Component }, i) => (
              <Fragment key={i}>
                <Route path={path} element={Component} />
              </Fragment>
            ))}
            <Route exact path={`/`} element={<Navigate to={`/dashboard`} />} />
          </>
        ) : (
          <>
            <Route exact path={`/`} element={<Signin />} />
            <Route
              exact
              path={`/forgot-password`}
              element={<ForgotPassword />}
            />
            <Route exact path={`/verify-code`} element={<VerifyCode />} />
            <Route exact path={`/reset-password`} element={<ResetPassword />} />
            <Route exact path={`/sign-up`} element={<Signup />} />
            <Route path={`/user-verified`} element={<UserVerified />} />
            <Route path={`/*`} element={<Navigate to={"/"} />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
